import React from "react";
import { Box, Typography, useTheme } from "@mui/material";

interface SimpleNamedRowItem {
  id: number;
  name: string;
  initiativeName?: string;
}

const SimpleNamedRow: React.FC<{ item: SimpleNamedRowItem }> = ({ item }) => {
  const theme = useTheme();
  const meta = [`ID: ${item.id}`, item.initiativeName]
    .filter(Boolean)
    .join(" | ");

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 700,
          color: theme.palette.text.primary,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {item.name}
      </Typography>
      <Typography
        sx={{
          fontSize: "12px",
          color: theme.palette.text.primary,
          lineHeight: 1.4,
        }}
      >
        {meta}
      </Typography>
    </Box>
  );
};

export default SimpleNamedRow;
